var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76934 2.5H20.564C21.2631 2.5 21.835 1.9375 21.835 1.25C21.835 0.5625 21.2631 0 20.564 0H2.76934C2.07026 0 1.49829 0.5625 1.49829 1.25C1.49829 1.9375 2.07026 2.5 2.76934 2.5ZM22.0384 4.75C21.924 4.175 21.4029 3.75 20.7928 3.75H2.54055C1.93045 3.75 1.40932 4.175 1.29492 4.75L0.023876 11C-0.12865 11.775 0.468743 12.5 1.2695 12.5H1.49829V18.75C1.49829 19.4375 2.07026 20 2.76934 20H12.9377C13.6368 20 14.2088 19.4375 14.2088 18.75V12.5H19.2929V18.75C19.2929 19.4375 19.8649 20 20.564 20C21.2631 20 21.835 19.4375 21.835 18.75V12.5H22.0638C22.8646 12.5 23.462 11.775 23.3095 11L22.0384 4.75ZM11.6667 17.5H4.04038V12.5H11.6667V17.5Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreGrey);
export default __webpack_public_path__ + "static/media/store_grey.795bb753bfc681951718b63f4ed6e6eb.svg";
export { ForwardRef as ReactComponent };